import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/lms-profiles.action'
import UploadFile from 'api/commons/UploadFile'
import IUploadFileMessageProps from '../../../interfaces/upload-file-message-props'
import i18n from 'i18n'

const prefix = 'configuration.lmsProfiles.upload.toast'
const uploadMessages = (): IUploadFileMessageProps => ({
  uploading: i18n.t(`${prefix}.uploading`),
  success: i18n.t(`${prefix}.success`),
  error: i18n.t(`${prefix}.error`),
})

const lmsProfilesUpload = (file: File) => {
  return UploadFile(file, '/lms_profiles/imports', uploadMessages())
}

function* lmsProfilesUploadEffectSaga(action: any) {
  try {
    const { data } = yield call(lmsProfilesUpload, action.payload)

    // dispatch action to change redux state
    yield put(fromActions.Actions.lmsProfilesUploadSuccess(data))
    yield put(fromActions.Actions.lmsProfileListReload())
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* lmsProfilesUploadWatcherSaga() {
  yield takeLatest(fromActions.LMS_PROFILES_UPLOAD, lmsProfilesUploadEffectSaga)
}
